import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { card } from "@/components/admin/SettingsPanel";

const FUND = { tithe: "Tithe", offering: "Offering", radio: "Radio Ministry" };

export const DonationsPanel = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/donations").then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
  }, []);
  const paid = rows.filter((r) => r.payment_status === "paid");
  const total = paid.reduce((s, r) => s + (Number(r.amount) || 0), 0);
  const byFund = Object.keys(FUND).map((k) => [k, paid.filter((r) => r.fund === k).reduce((s, r) => s + (Number(r.amount) || 0), 0)]);

  return (
    <div data-testid="donations-panel" className="grid gap-4">
      <div className="grid gap-4 sm:grid-cols-4">
        <div className={card}>
          <p className="font-ui text-xs uppercase tracking-widest text-[#B7BFCC]">Total received</p>
          <p data-testid="donations-total" className="font-display mt-2 text-4xl text-[#D4AF37]">${total.toFixed(2)}</p>
        </div>
        {byFund.map(([k, v]) => (
          <div key={k} className={card}>
            <p className="font-ui text-xs uppercase tracking-widest text-[#B7BFCC]">{FUND[k]}</p>
            <p className="font-display mt-2 text-3xl text-[#F4EEE2]">${v.toFixed(2)}</p>
          </div>
        ))}
      </div>
      <div className={card}>
        {!rows.length && <p className="text-sm text-[#B7BFCC]">No gifts yet.</p>}
        {rows.map((r) => (
          <div key={r.session_id} data-testid={`donation-row-${r.session_id}`} className="flex flex-wrap items-center justify-between gap-2 border-b border-[#F4EEE2]/10 py-3 last:border-0">
            <div className="min-w-0">
              <p className="truncate font-ui text-sm font-semibold text-[#F4EEE2]">{r.donor_name || "Anonymous"} <span className="font-normal text-[#B7BFCC]">· {FUND[r.fund] || r.fund}</span></p>
              <p className="truncate text-xs text-[#9AA4B4]">{r.donor_email || r.donor_email_checkout || "—"} · {String(r.created_at || "").slice(0, 10)}</p>
            </div>
            <p className={`font-mono text-sm ${r.payment_status === "refunded" ? "text-[#F2A08A] line-through" : "text-[#D4AF37]"}`}>${Number(r.amount || 0).toFixed(2)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
